import { render, staticRenderFns } from "./FaresTable.vue?vue&type=template&id=40434ded&"
import script from "./FaresTable.vue?vue&type=script&lang=js&"
export * from "./FaresTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports